export enum LoginMode {
  NO_PASSWORD = "no_password",
  COMMON_PASSWORD = "common_password",
  INDIVIDUAL_PASSWORD = "individual_password"
}

export const BLOCKED_ODDBODS_CATEGORY = 'oddbods_books';
export const BLOCKED_BROB_MILESTONE_CODE = 'brob';

export const IS_SPLASH_LEAGUE_INTRO_PHASE = false //new Date() < new Date('2025-09-08');